import { render } from "./AppRadioButton.vue?vue&type=template&id=28c4d8bb&ts=true"
import script from "./AppRadioButton.vue?vue&type=script&lang=ts"
export * from "./AppRadioButton.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__